<template>
  <section>
<!--     
    <div class="alert alert-info" role="alert">
      Masuk Sebagai 
    </div>
 -->
    <div class="row">

      <div class="col-xl-4 col-md-6 mb-4">
        <div class="card border-left-info shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="h6 font-weight-bold text-primary text-uppercase mb-1">
                  Instansi / OPD
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ userCompany.Name }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-building fa-3x text-gray-600" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-6 mb-4">
        <div class="card border-left-primary shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="h6 font-weight-bold text-primary text-uppercase mb-1">
                  Total Pegawai
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ totalEmployees }}
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-users fa-3x text-gray-600" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-4 col-md-6 mb-4">
        <div class="card border-left-warning shadow h-100 py-2" v-if="$constant.APP === 'SIAPMAN'">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="h6 font-weight-bold text-primary text-uppercase mb-1">
                  Koneksi Mesin ke Server
                </div>
                <div class="h6 mb-0 font-weight-bold text-gray-800" v-if="!machines.length">
                  Tidak ada mesin terdeteksi
                  <i class="fas fa-times-circle fa-lg text-danger" />
                </div>
                <div class="h6 mb-0 font-weight-bold text-gray-800" v-else v-for="machine in machines" :key="machine.ID">
                  {{ machine.Name }} : 
                  <span v-if="machine.Active === 1">
                    Terhubung
                    <i class="fas fa-check fa-lg text-success" />
                  </span>
                  <span v-else>
                    Tidak Terhubung
                    <i class="fas fa-times-circle fa-lg text-danger" />
                  </span>
                  <!-- {{ (machine.Active === 1) ? 'Terhubung ke Server' : 'Tidak Terhubung ke Server' }} -->
                </div>
              </div>
<!-- 
              <div class="col-auto">
              </div>
 -->
            </div>
          </div>
        </div>

        <div class="card border-left-warning shadow h-100 py-2" v-else>
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <div class="col mr-2">
                <div class="h6 font-weight-bold text-primary text-uppercase mb-1">
                  Kondisi koneksi ke server
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  Terhubung ke Server
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-check fa-3x text-success" />
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
   
  </section>
</template>

<script>
export default {
  mounted() {
    this.fetchData()
  },

  data() {
    return {
      totalEmployees: 0,
      // machineActive: false,
      machines: [
        // {
        //   Name: 'tes1',
        //   Active: 0
        // },
        // {
        //   Name: 'tes2',
        //   Active: 1
        // }
      ]
    }
  },

  computed: {
    userCompany () {
      return this.$store.getters['user/userCompany']
    }
  },

  methods: {
    fetchData () {
      this.$axios.get(`employee/count?companyId=${this.userCompany.ID}`).then((res) => {
        this.totalEmployees = res.data
      })

      this.$axios.get(`machine?companyId=${this.userCompany.ID}`).then((res) => {
        this.machines = res.data
        // if (res.data.length) {
        //   this.machineActive = (res.data[0].Active === 1) ? true :false
        // } else {
        //   this.machineActive = false
        // }
      })

      // this.$axios.get(`employee/count`, { params: { employeeType: 'pns' }}).then((res) => {
      //   this.totalEmployeesPNS = res.data
      // })

      // this.$axios.get(`employee/count`, { params: {employeeType: 'blud' }}).then((res) => {
      //   this.totalEmployeesKontrak = res.data
      // })

      // this.$axios.get(`employee/count`, { params: {employeeType: 'pemda' }}).then((res) => {
      //   this.totalEmployeesPemda = res.data
      // })

      // this.$axios.get(`employee-assignment/count-warning`).then((res) => {
      //   this.totalAssignmentWarning = res.data
      // })

      // this.$axios.get(`employee-assignment/count-danger`).then((res) => {
      //   this.totalAssignmentDanger = res.data
      // })
    }
  }
}  
</script>